export default __webpack_public_path__ + "db84aa427d60dbb5a1593dc6ec810fd0.png";